import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AppLink } from '../../common/appLinks/appLinksCfg.service';
import { AppLinkNavigatorService } from '../../common/appLinks/appLinkNavigator.service';

@Component({
    selector: 'launcher-app-card',
    templateUrl: './launcherAppCard.component.html',
    styleUrls: ['./launcherAppCard.component.css'],
    host: { class: 'col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 cardAppWrapper' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LauncherAppCardComponent {
    constructor(private appLinkNavigatorService: AppLinkNavigatorService) {

    }

    @Input() public appLink: AppLink;
    @Input() public isMobile: boolean = false;
    @Output() click = new EventEmitter<void>();

    public onClick(event: Event) {
        if (event) event.stopPropagation();
        this.click.emit();
        this.appLinkNavigatorService.navigate(this.appLink);
    }
}
